import { useEffect, useRef } from "react";
import { useScrollToTop } from "../../../../hooks/useScrollToTop";
import { mt } from "../../../../utils/tracking";
import { useParams } from "react-router-dom";
import { usePolicy } from "../../../PolicyDetails/usePolicy";
import { NotFound } from "../../../../not-found";
import { PolicyDetails } from "shared/types/PolicyExtended.types";
import { validateState } from "shared/utils/validateState/validateState";
import { getStateName } from "shared/utils/getStateName/getStateName";
import styles from "./PaymentMethodPage.module.scss";
import { routes } from "../../../../routing/routes";
import { SettingsContainer } from "../../../SettingsContainer";
import { unstable__Button as Button } from "@hagerty/react-components";
import { ArrowLeft } from "@hagerty/icons";
import { clsx } from "clsx";

export default function PaymentMethodPage() {
  useScrollToTop();
  const { policyNumber } = useParams();
  const policy = usePolicy(policyNumber as string);

  if (!policy || policy.source === "APEX") {
    return <NotFound />;
  }

  return <PaymentMethodPageWrapped policy={policy} />;
}

const PaymentMethodPageWrapped = ({ policy }: { policy: PolicyDetails }) => {
  const topOfFormRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    mt.trackView();
  }, []);

  const policyName = `${getStateName(
    validateState(policy.stateRegion)
  )} policy`;

  return (
    <SettingsContainer paperClassName={styles.paper}>
      <Button
        className={styles.backButton}
        aria-label="Cancel and go back"
        variant="text"
        size="small"
        iconLeft={{
          icon: ArrowLeft,
        }}
        onClick={() => routes.go(routes.policyDetails(policy.policyNumber))}
      >
        Back
      </Button>
      <div className={styles.policyName}>{policyName}</div>
      <h2 className={clsx("mb-2 mb-sm-3", styles.heading)} ref={topOfFormRef}>
        Payment method
      </h2>
      <PaymentIFrame />
    </SettingsContainer>
  );
};

// TODO: This will be replaced with the payment services iframe.
const PaymentIFrame = () => (
  <div className={styles.paymentIframe}>
    <p>
      TODO:{" "}
      <a
        href="https://dev.azure.com/hagerty/Hagerty/_git/ts-payment-form-ui?path=%2Fdocs%2Fonboarding.md&version=GBdevelop&_a=preview"
        target="_blank"
        rel="noreferrer"
      >
        Payment Services iFrame
      </a>
    </p>
  </div>
);
